var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: ["tabList", "px-6", "md:px-16", "pb-36", _vm.slug] },
    [
      _vm._l(_vm.items, function(item) {
        return _c(
          "div",
          {
            key: item.id,
            staticClass: "tab",
            on: {
              click: function($event) {
                return _vm.openModal(item)
              }
            }
          },
          [
            _c("div", { staticClass: "heading" }, [
              _c("h2", [_vm._v(_vm._s(item.heading))]),
              _vm._v(" "),
              item.rsf
                ? _c("p", { staticClass: "sqft" }, [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(item.rsf.toLocaleString()) +
                        " RSF\n\t\t\t"
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "indicator" }, [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "14",
                    fill: "none"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "#29261E",
                      d: "M0 8V6h12L8 2l1-2 7 7-7 7-1-2 4-4H0z"
                    }
                  })
                ]
              )
            ])
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modals" },
        _vm._l(_vm.items, function(item) {
          return _c(
            "div",
            {
              key: item.id,
              class: [
                "modal",
                { active: _vm.activeModal === item.id || _vm.modal === item.id }
              ]
            },
            [
              item.type === "floor"
                ? _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "div",
                      { staticClass: "close", on: { click: _vm.dismissModal } },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "18",
                              height: "18",
                              fill: "none"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "#58554D",
                                "fill-rule": "evenodd",
                                d:
                                  "M16 .5L17.5 2l-7 7 7 7-1.5 1.5-7-7-7 7L.5 16l7-7-7-7L2 .5l7 7 7-7z",
                                "clip-rule": "evenodd"
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "intro" }, [
                      _c("h3", { staticClass: "h2" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(item.heading) +
                            "\n\t\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      item.rsf
                        ? _c("p", { staticClass: "sqft" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(item.rsf.toLocaleString()) +
                                " RSF\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    item.images.length > 0
                      ? _c(
                          "div",
                          { staticClass: "building-image" },
                          _vm._l(item.images, function(image) {
                            return _c("img", {
                              key: image.id,
                              attrs: {
                                src: image.url,
                                alt: image.title,
                                loading: "lazy"
                              }
                            })
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "copy",
                      domProps: { innerHTML: _vm._s(item.copy) }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ctas" },
                      [
                        item.cta.length
                          ? _c(
                              "a",
                              {
                                staticClass: "cta",
                                attrs: { href: "/" + item.cta[0].slug }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(item.ctaCopy) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(item.floorplan, function(floorplan) {
                          return _c(
                            "a",
                            {
                              key: floorplan.id,
                              staticClass: "download",
                              attrs: {
                                href: floorplan.url,
                                target: "_blank",
                                rel: "noopener"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\tDownload Floorplan\n\t\t\t\t\t"
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm._l(item.stackingPlan, function(stackingPlan) {
                          return _c(
                            "a",
                            {
                              key: stackingPlan.id,
                              staticClass: "download",
                              attrs: {
                                href: stackingPlan.url,
                                target: "_blank",
                                rel: "noopener"
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\tDownload Stacking Plan\n\t\t\t\t\t"
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                : item.type === "directions"
                ? _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "close" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "18",
                            height: "18",
                            fill: "none"
                          },
                          on: {
                            click: function($event) {
                              _vm.activeModal = ""
                              _vm.activeSubTab = "ingress"
                            }
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "#58554D",
                              "fill-rule": "evenodd",
                              d:
                                "M16 .5L17.5 2l-7 7 7 7-1.5 1.5-7-7-7 7L.5 16l7-7-7-7L2 .5l7 7 7-7z",
                              "clip-rule": "evenodd"
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    item.ingress && item.egress
                      ? _c("div", { staticClass: "tabs" }, [
                          _c("ul", { staticClass: "row" }, [
                            _c(
                              "li",
                              {
                                class: [
                                  "col",
                                  "ingress",
                                  { active: _vm.activeSubTab === "ingress" }
                                ],
                                on: {
                                  click: function($event) {
                                    _vm.activeSubTab = "ingress"
                                  }
                                }
                              },
                              [_vm._v("\n\t\t\t\t\t\t\tIngress\n\t\t\t\t\t\t")]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                class: [
                                  "col",
                                  "egress",
                                  { active: _vm.activeSubTab === "egress" }
                                ],
                                on: {
                                  click: function($event) {
                                    _vm.activeSubTab = "egress"
                                  }
                                }
                              },
                              [_vm._v("\n\t\t\t\t\t\t\tEgress\n\t\t\t\t\t\t")]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "heading" }, [
                        _c("h2", [_vm._v(_vm._s(item.heading))])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "copy" }, [
                        _c(
                          "div",
                          {
                            class: [
                              "ingress",
                              { active: _vm.activeSubTab === "ingress" }
                            ]
                          },
                          [
                            _c("div", {
                              staticClass: "mb-4",
                              domProps: { innerHTML: _vm._s(item.ingress) }
                            }),
                            _vm._v(" "),
                            item.ingressMap.length > 0
                              ? _c("img", {
                                  attrs: {
                                    src: item.ingressMap[0].url,
                                    alt: item.ingressMap[0].title
                                  }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: [
                              "egress",
                              { active: _vm.activeSubTab === "egress" }
                            ]
                          },
                          [
                            _c("div", {
                              staticClass: "mb-4",
                              domProps: { innerHTML: _vm._s(item.egress) }
                            }),
                            _vm._v(" "),
                            item.egressMap.length > 0
                              ? _c("img", {
                                  attrs: {
                                    src: item.egressMap[0].url,
                                    alt: item.egressMap[0].title
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ]
          )
        }),
        0
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }